/* eslint-disable */
var MakeChart = function (opts, callback) {
  var d3 = require("d3");
  var _ = require("underscore");

  function BeeSwarm(opts, callback) {
    var This = this;
    this.opts = opts;

    opts.data = _.filter(opts.data, function (d) {
      return d[This.opts.chartType] !== null;
    });

    var percentDecrease = 1;
    /// 870 MAX WIDTH

    if (!this.opts.width || this.opts.width > 870) {
      this.margin = { top: 20, right: 20, bottom: 40, left: 20 };
      this.width = 870 - this.margin.left - this.margin.right;
      this.height = 480 - this.margin.top - this.margin.bottom;
    } else {
      var percentDecrease = 870 / this.opts.width;
      this.margin = {
        top: 20 / percentDecrease,
        right: 20 / percentDecrease,
        bottom: 40 / percentDecrease,
        left: 20 / percentDecrease,
      };
      this.width = 870 / percentDecrease - this.margin.left - this.margin.right;
      this.height =
        480 / percentDecrease - this.margin.top - this.margin.bottom;
    }

    this.x = d3
      .scaleLinear()
      .domain(
        d3.extent(this.opts.data, function (d) {
          return Number(d[opts.chartType]);
        })
      )
      .range([this.margin.left, this.width - this.margin.right]);

    this.dodge = function (data, radius) {
      var radius2 = Math.pow(radius, 2);
      var circles = data
        .map(function (d) {
          return {
            x: This.x(Number(d[opts.chartType])),
            data: d,
          };
        })
        .sort(function (a, b) {
          return a.x - b.x;
        });
      var epsilon = 1e-3;
      var head = null,
        tail = null;

      // Returns true if circle ⟨x,y⟩ intersects with any circle in the queue.
      function intersects(x, y) {
        var a = head;
        while (a) {
          if (radius2 - epsilon > Math.pow(a.x - x, 2) + Math.pow(a.y - y, 2)) {
            return true;
          }
          a = a.next;
        }
        return false;
      }

      // Place each circle sequentially.
      for (var i = 0; i < circles.length; i++) {
        var b = circles[i];
        // Remove circles from the queue that can’t intersect the new circle b.
        while (head && head.x < b.x - radius2) head = head.next;

        // Choose the minimum non-intersecting tangent.
        if (intersects(b.x, (b.y = 0))) {
          var a = head;
          b.y = Infinity;
          do {
            var y = a.y + Math.sqrt(radius2 - Math.pow(a.x - b.x, 2));
            if (y < b.y && !intersects(b.x, y)) b.y = y;
            a = a.next;
          } while (a);
        }

        // Add b to the queue.
        b.next = null;
        if (head === null) head = tail = b;
        else tail = tail.next = b;
      }

      return circles;
    };

    d3.select("#svg_" + this.opts.id).remove();

    this.svg = d3
      .select("#" + this.opts.id)
      .append("svg")
      .attr("width", this.width)
      .attr("height", this.height)
      .attr("id", "svg_" + this.opts.id);

    this.init();

    if (callback) {
      if (this.BeeSwarm) {
        callback(this.BeeSwarm.html());
      } else {
        callback();
      }
    }
  }

  BeeSwarm.prototype.init = function () {
    var This = this;
    var data = this.opts.data;

    // Add white background

    if (!this.isServerSide) {
      this.toolTipEl = d3
        .select(window.document.body)
        .append("div")
        .attr("class", "tooltip")
        .style("id", "tooltip_" + This.opts.id)
        .style("opacity", 0)
        .style("posiition", "absolute")
        .style("position", "absolute")
        .style("padding", "6px")
        .style("font", "12px sans-serif")
        .style("background", "#ffffff")
        .style("line-height", 1.8)
        .style("border", "solid 1px #000")
        .style("border-radius", "8px")
        .style("pointer-events", "none");
    }

    this.svg
      .append("rect")
      .attr("height", "100%")
      .attr("width", "100%")
      .attr("fill", "#e8e8e8");

    this.svg
      .append("g")
      .style("font-family", "'Roboto Condensed'")
      .style("font-size", ".8rem")
      .attr(
        "transform",
        "translate(0," + (This.height - This.margin.bottom) + ")"
      )
      .call(
        d3
          .axisBottom(This.x)
          .tickSizeOuter(0)
          .tickFormat(function (d) {
            return getSuffix(Number(d), This.opts.xVal);
          })
      );

    var scaleRadius = d3
      .scaleLinear()
      .domain([0, 100, This.width, 9999])
      .range([0.5, 0.5, 2.5, 2.5]);
    var radius = scaleRadius(This.width);
    var scalePadding = d3
      .scaleLinear()
      .domain([0, 100, This.width, 9999])
      .range([0.5, 0.5, 2, 2]);

    var padding = scalePadding(This.width);

    This.svg
      .append("g")
      .selectAll("circle")
      .data(This.dodge(data, radius * 2 + padding))
      .enter()
      .append("circle")
      .attr("cx", function (d) {
        return d.x;
      })
      .attr("cy", function (d) {
        return This.height - This.margin.bottom - radius - padding - d.y;
      })
      .attr("r", radius)
      .style("fill", function (d) {
        if (
          This.opts.filter.length >= 3 &&
          d.data.player_name
            .toUpperCase()
            .indexOf(This.opts.filter.toUpperCase()) > -1
        ) {
          return "#f00";
        }
        if (Number(d.data.player_id) == Number(This.opts.playerId)) {
          return "#f00";
        } else {
          return "#399098";
        }
      })
      .on("mouseover", function (d) {
        var year = "";
        if (d.data.year) {
          year = " - " + d.data.year;
        }
        This.toolTipEl.style("opacity", 0.9);
        This.toolTipEl
          .html(
            d.data.player_name +
              " - " +
              getSuffix(Number(d.data[This.opts.chartType]), This.opts.xVal) +
              year
          )
          .style("left", d3.event.pageX + 10 + "px")
          .style("top", d3.event.pageY - 10 + "px");
      })
      .on("mouseout", function (d) {
        This.toolTipEl.style("opacity", 0);
      });

    This.svg
      .append("text")
      .attr("x", This.width / 2)
      .attr("y", This.margin.top + This.margin.bottom / 2)
      .style("font-family", "'Roboto Condensed'")
      .style("font-size", "1rem")
      .attr("text-anchor", "middle")
      .text(This.opts.xTitle + " Breakdown");
  };

  function getSuffix(value, type) {
    if (
      type === "ba" ||
      type === "slg" ||
      type === "iso" ||
      type === "xba" ||
      type === "woba" ||
      type === "xwoba" ||
      type === "xiso" ||
      type === "xobp" ||
      type === "obp" ||
      type == "xbacon" ||
      type === "babip" ||
      type === "wobacon" ||
      type === "xwobacon" ||
      type === "batting_avg" ||
      type === "slg_percent" ||
      type === "on_base_percent" ||
      type === "on_base_plus_slg" ||
      type === "isolated_power" ||
      type === "bacon" ||
      type === "xbacon" ||
      type === "xslg" ||
      type === "xslgdiff" ||
      type === "xbadiff" ||
      type === "wobadiff"
    ) {
      return value.toFixed(3).replace("0.", ".");
    }

    if (type === "eff_min_vel") {
      return value.toFixed(1) + " MPH";
    }
    if (
      type === "velocity" ||
      type === "launch_speed" ||
      type === "exit_velocity_avg" ||
      type === "maxeff_arm_2b_3b_sba"
    ) {
      return value.toFixed(0) + " MPH";
    }
    if (
      type === "pitch_percent" ||
      type === "swing_and_miss" ||
      type.indexOf("_percent") > -1
    ) {
      return value.toFixed(0) + "%";
    }
    if (type === "rounded_sprint_speed") {
      return value.toFixed(1) + "ft/s";
    }
    if (type === "release_extension") {
      return value.toFixed(1) + "ft.";
    }
    if (
      type === "x0" ||
      type === "z0" ||
      type === "release_pos_x" ||
      type === "release_pos_z" ||
      type === "px" ||
      type === "pz" ||
      type === "plate_x" ||
      type === "plate_z"
    ) {
      return value.toFixed(1) + "	ft";
    }
    if (type.indexOf("start_distance") > -1) {
      return value.toFixed(0) + "ft";
    }

    if (type === "exchange_2b_3b_sba") {
      return value.toFixed(2) + "sec";
    }
    if (type === "spin_rate") {
      return value.toFixed(0) + " RPM";
    }
    return value.toFixed(0);
  }

  function getDomain(val, axis, data) {
    var domain = {};
    domain.min = d3.min(data, function (d) {
      return d[axis];
    });

    domain.max = d3.max(data, function (d) {
      return d[axis];
    });

    return domain;
  }

  if (callback) {
    new BeeSwarm(opts, function (svg) {
      callback(svg);
    });
  } else {
    new BeeSwarm(opts);
  }
};

module.exports = { MakeChart: MakeChart };
